<div class="summary-desktop">
  <div class="summary-section">
    <p>
      {{ 'new_strategy.risk_screen.slider.stocks' | translate }}
      <app-ui-tooltip
        [content]="
          'new_strategy.portfolio_screen.stock_ratio.tooltip'
            | translate: { percentage: investmentData.stock_split * 100 | translatePercent: language : (step === 5 ? 1 : 0) }
        "
        color="yellow"
        size="small"
        (mouseenter)="trackTooltip('stockRatio')"
      ></app-ui-tooltip>
    </p>
    <p class="numbers">
      {{ getStockBondValue('stock') | translatePercent: language : (step === 5 ? 1 : 0) }}
    </p>
  </div>
  <div class="summary-section">
    <p>
      <span [innerHTML]="'strategy.stockSplit.bonds' | translate"></span>
      <app-ui-tooltip [content]="'bonds.tooltip.p' | translate" color="yellow" size="small" (mouseenter)="trackTooltip('bonds')"></app-ui-tooltip>
    </p>
    <p class="numbers">
      {{ getStockBondValue('bond') | translatePercent: language : (step === 5 ? 1 : 0) }}
    </p>
  </div>
  <div class="summary-section">
    <p>
      {{ (step === 5 ? 'new_strategy.risk_screen.invested' : 'new_strategy.risk_screen.input1') | translate }}
      <span class="grey">{{ investmentData.currency }}</span>
    </p>
    <p class="numbers">
      {{ (investmentData.total > 0 ? investmentData.total : 0) | translateNumber: language }}
    </p>
  </div>
  <div class="summary-section">
    <p>
      {{ 'new_strategy.risk_screen.input2' | translate }} <span class="grey">{{ investmentData.currency }}</span>
    </p>
    <p class="numbers">{{ investmentData.monthly_investment | translateNumber: language }}</p>
  </div>
  <ng-container *ngIf="investmentData.stock_split !== 0">
    <div class="bar-holder">
      <div class="bar-stocks" [style.width.%]="investmentData.stock_split * 100"></div>
    </div>
  </ng-container>
</div>
